import classNames from 'classnames';
import styles from './styles.module.scss';
import { Button, Dropdown as BsDropdown } from 'react-bootstrap';
import Tooltip from '../../../../tooltip';
import DocumentAttachmentItem from './documentAttachmentItem';
import { ATTACHMENTS_COUNTERPARTY_WARNING } from '../../constants/EditorConstats';
import { Warning } from '../../../../shared/warning';
import { Dropdown, DropdownBody, DropdownToggleBlue } from '../../../../dropdown';

interface DocumentAttachmentsSidebarProps {
  attachments: any[];
  handleFileUploadModal: () => void;
  handleDealDocumentPickerModal: () => void;
  handleRemoveAttachmentClick: (id: any) => void;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  canUpload: boolean;
}

const DocumentAttachmentsSidebar = ({
  attachments,
  handleFileUploadModal,
  handleDealDocumentPickerModal,
  handleRemoveAttachmentClick,
  moveItem,
  canUpload = false,
}: DocumentAttachmentsSidebarProps) => {
  const MANAGE_ATTACHMENTS_TOOLTIP =
    'Attachments will be added to the end of the document when sent for signing or exported.';

  const ATTACHMENTS_LIMIT = 10;

  const isAtLimit = attachments.length >= ATTACHMENTS_LIMIT;

  return (
    <div className={classNames(styles.attachmentSidebarWrapper)}>
      <div className={styles.attachmentsSidebarHeader}>
        <h2>Attachments</h2>
        <Tooltip testId="manage-attachments-tooltip" placement="right">
          {MANAGE_ATTACHMENTS_TOOLTIP}
        </Tooltip>
      </div>
      {canUpload && (
        <div className="d-flex justify-content-between align-items-center w-100 pb-4">
          <Dropdown className="w-100">
            <Dropdown.Toggle
              id="dropdown-attach-document"
              as={DropdownToggleBlue}
              className="w-100"
              disabled={!canUpload || isAtLimit}
            >
              Attach Document
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
              <DropdownBody>
                <BsDropdown.Item as={Button} variant="link" onClick={handleFileUploadModal}>
                  Upload PDF
                </BsDropdown.Item>
                <BsDropdown.Item as={Button} variant="link" onClick={handleDealDocumentPickerModal}>
                  Deal Document
                </BsDropdown.Item>
              </DropdownBody>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
      {attachments.length === 0 && <div className={styles.noAttachments}>No attachments found.</div>}
      {attachments.length > 0 && (
        <>
          {canUpload && (
            <div className="pl-1 pr-1 m-auto">
              <Warning text={ATTACHMENTS_COUNTERPARTY_WARNING} largeCentered />
            </div>
          )}

          <div className={styles.attachmentsList}>
            {attachments.map((extraAttachment, idx) => (
              <DocumentAttachmentItem
                key={extraAttachment.id}
                id={extraAttachment.id}
                index={idx}
                moveItem={moveItem}
                attachment={extraAttachment.attachment}
                linkedDocument={extraAttachment.linkedDocument}
                canManipulate={canUpload}
                handleRemoveAttachmentClick={handleRemoveAttachmentClick}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default DocumentAttachmentsSidebar;
